import React from 'react'
import Footer from '../../components/footer/Footer'
import ContactBanner from '../../components/ContactBanner/ContactBanner'
import MarqueeSlider from '../../components/MarqueeSlider/MarqueeSlider'
import ServicesComponents from '../../components/servicesComponents/ServicesComponents'

const HrService = ({ isRtl, toggleLanguage }) => {
  return (
    <>
      <ContactBanner isRtl={isRtl} />
      <MarqueeSlider/>
      <ServicesComponents isRtl={isRtl} />
      <Footer isRtl={isRtl} />
    </>
  )
}

export default HrService